// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"9":"all-document","188":"create-transaction","535":"login","857":"document"}[chunkId] + "." + {"9":"1a9addce","188":"71af9543","535":"4ec10ad6","857":"f7bc82d2"}[chunkId] + ".css";
};